import { isPlatformError } from '@agentic/contracts';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQuery } from '../app/queries.ts';
import { Shell } from '../app/shell.tsx';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery);
    } catch (error) {
      if (isPlatformError(error) && error.code === 'unauthorized') {
        throw redirect({ to: '/login', search: { redirect: location.href } });
      }
      throw error;
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const { data } = useSuspenseQuery(meQuery);
  return (
    <Shell principal={data.principal}>
      <Outlet />
    </Shell>
  );
}
